import { ReduxState } from 'src/lib/redux/store';

export const selectRecordPollList = (state: ReduxState) => state.pollSlice.recordPollList;
export const selectIsPollInRecordEnabled = (state: ReduxState): boolean =>
  state.pollSlice.isPollInRecordEnabled;
export const selectActivePollResult = (state: ReduxState) => state.pollSlice.pollResult;
export const selectTotalPollsConducted = (state: ReduxState) => state.pollSlice.totalPollsConducted;
export const selectUserSelfResult = (state: ReduxState) => state.pollSlice.userSelfResult;
export const selectActivePollState = (state: ReduxState) => state.pollSlice.activePollState;
export const selectRecordPollAttemptedMap = (state: ReduxState) =>
  state.pollSlice.recordPollAttemptedMap;
export const selectActivePollDetails = (state: ReduxState) => state.pollSlice.activePollDetails;
export const selectPollMappingBySecond = (state: ReduxState) => state.pollSlice.pollIdBySecondMap;
export const selectPollSelectedValues = (state: ReduxState) => state.pollSlice.pollSelectedValues;
export const selectIsRecordPollFeedbackEnabled = (state: ReduxState): boolean =>
  state.pollSlice.isPollFeedbackEnabled;
export const selectPollAttemptedByStudent = (state: ReduxState) =>
  state.pollSlice.isPollAttemptedByStudent;
export const selectIsDisableScreenFeature = (state: ReduxState) =>
  state.pollSlice.isDisableScreenFeature;
export const selectDisableFeatureList = (state: ReduxState) => state.pollSlice.disableFeatureList;
export const selectDisableToolTipText = (state: ReduxState) => state.pollSlice.disableToolTipText;
export const selectOpenPollFeedbackStrip = (state: ReduxState) =>
  state.pollSlice.openPollFeedbackStrip;
export const selectRecordPollAttemptTimer = (state: ReduxState) =>
  state.pollSlice.recordPollAttemptTimer;
export const selectIsPollFeedbackSubmitted = (state: ReduxState) =>
  state.pollSlice.isPollFeedbackSubmitted;
